export default {
    common: {
        appName: 'Swift Invoice',
        cancel: 'Kanselahin',
        email: 'Email',
        password: 'Password',
        or: 'o',
        change: 'Palitan',
        delete: 'Tanggalin',
        save: 'I-save',
        edit: 'I-edit',
        add: 'Idagdag',
        close: 'Isara',
        date: 'Petsa',
        total: 'Kabuuan',
        status: 'Status',
        amount: 'Halaga',
        quantity: 'Dami',
        rate: 'Rate',
        tax: 'Buwis',
        discount: 'Diskwento',
        note: 'Tala',
        notes: 'Mga Tala',
        description: 'Paglalarawan',
        client: 'Kliyente',
        item: 'Item',
        items: 'Mga Item',
        type: 'Uri',
        category: 'Kategorya',
        phone: 'Telepono',
        name: 'Pangalan',
        subject: 'Paksa',
        saveAndClose: 'I-save at Isara',
        saveAndSendEmail: 'I-save at Magpadala ng Email',
        sendEmail: 'Magpadala ng email',
        send: 'Ipadala',
        print: 'I-print',
        moreActions: 'Higit pang mga aksyon',
        preparingPdf: 'Inihahanda ang PDF...',
        pdfPreparationFailed: 'Hindi maihanda ang PDF',
        warning: 'Babala',
        ok: 'OK',
        uploadSuccess: 'tagumpay ang pag-upload',
        saveSuccess: 'tagumpay ang pag-save',
        deleteSuccess: 'tagumpay ang pagtanggal',
        deleteFailed: 'bigo ang pagtanggal',
        saveFailed: 'bigo ang pag-save',
        loadFailed: 'bigo ang pag-load',
        systemError: 'error sa sistema',
        sendSuccess: 'tagumpay ang pagpapadala',
        updateSuccess: 'tagumpay ang pag-update',
        unsavedChangesMsg: 'Mayroon kang mga hindi na-save na pagbabago. Gusto mo ba itong i-save o itapon?',
        saveChangesTitle: 'I-save ang mga pagbabago?',
        confirmSave: 'I-save',
        discard: 'Itapon',
        validEmail: 'Mangyaring maglagay ng tamang email address',
        deleteFailedMsg: 'bigo ang pagtanggal',
        shipping: 'Pagpapadala',
        attachment: 'Kalakip',
        days: 'Mga Araw',
        excl: '(hindi kasama)',
        incl: '(kasama)',
        of: 'ng'
    },
    login: {
        heroPrefix: 'Matalinong ',
        heroInvoicing: 'Invoicing',
        heroMiddle: ',',
        heroSimplified: 'Pinapadali',
        heroSuffix: ' para sa Iyo.',
        subtitle1: 'Lumikha, magpadala, at pamahalaan ang mga invoice nang walang kahirap-hirap.',
        subtitle2: 'Makatanggap ng bayad nang mas mabilis sa Swift Invoice.',
        feature1Title: 'Propesyonal na mga Invoice',
        feature1Text: 'Lumikha ng magagandang invoice sa loob ng ilang minuto',
        feature2Title: 'Real-time na Pagsubaybay',
        feature2Text: 'Subaybayan ang mga pagbabayad at status ng invoice',
        feature3Title: 'Ligtas at Maaasahan',
        feature3Text: 'Ligtas ang iyong data sa enterprise-grade na seguridad',
        welcomeBack: 'Maligayang pagbabalik',
        signInToContinue: 'Mag-sign in sa iyong account upang magpatuloy',
        enterEmail: 'Ilagay ang iyong email',
        enterPassword: 'Ilagay ang iyong password',
        rememberMe: 'Tandaan ako',
        forgotPassword: 'Nalimutan ang password?',
        signIn: 'Mag-sign in',
        signingIn: 'Nag-sign in…',
        continueWithGoogle: 'Magpatuloy sa Google',
        continueWithApple: 'Magpatuloy sa Apple',
        createAccount: 'Lumikha ng account',
        startUsing: 'Simulang gamitin ang Swift Invoice',
        companyName: 'Pangalan ng kumpanya',
        enterCompanyName: 'Ilagay ang pangalan ng iyong kumpanya',
        alreadyHaveAccount: 'Mayroon nang account? Mag-sign in',
        footerRights: '© 2026 Swift Invoice. Nakalaan ang lahat ng karapatan.',
        termsOfService: 'Mga Tuntunin ng Serbisyo',
        contactUs: 'Makipag-ugnayan sa amin: goodinvoicego@gmail.com',
        betaDialogBody: 'Nakumpleto ng aming koponan ang unang bersyon ng web <br> Ang bersyong ito ay magagamit lamang ng mga gumagamit ng iPhone <br> Papahusayin namin ang web function sa lalong madaling panahon at bubuksan ito para sa lahat <br>',
        ieDialogBody: 'Paumanhin, dahil may problema sa compatibility ang IE browser, hindi pa namin sinusuportahan ang IE browser sa kasalukuyan, kung kailangan mong gamitin, mangyaring i-download',
        resetPasswordTitle: 'I-reset ang password',
        sendResetEmail: 'Magpadala ng reset email',
        resetEmailSent: 'Naipadala na ang email para i-reset ang password. Mangyaring suriin ang iyong inbox.',
        bindingTitle: 'I-link ang umiiral na account',
        bindingHintPrefix: 'May account na ang gumagamit ng email ',
        bindingHintSuffix: ". Ilagay ang password ng account na iyon upang i-link ang iyong Google sign-in.",
        enterAccountPassword: 'Ilagay ang password ng account',
        linkAccount: 'I-link ang account',
        validEmail: 'Mangyaring maglagay ng tamang email address',
        validPassword: 'Dapat ay 6 o higit pang character ang password',
        validCompanyName: 'Mangyaring punan ang pangalan ng iyong kumpanya'
    },
    account: {
        title: 'Account',
        profile: 'Profile',
        swiftAccount: 'Swift Invoice account',
        connectSocial: 'Ikonekta ang mga social account',
        companyLogo: 'Logo ng kumpanya',
        addLogo: 'Magdagdag ng logo',
        uploading: 'ina-upload...',
        currentPlan: 'Kasalukuyang plano: Swift {plan}',
        planActiveUntil: 'Aktibo ang plano hanggang {date}',
        sharedWithMobile: 'Ibinahagi sa mobile',
        subscriptionExpired: 'Natapos na ang iyong subscription',
        planNote: 'Mag-log in muli kung hindi pa na-update ang status ng iyong subscription.',
        upgradeToPro: 'Mag-upgrade sa Swift Pro',
        viewPlans: 'Tingnan ang mga subscription plan',
        connecting: 'Kumokonekta…',
        connectGoogle: 'Ikonekta ang Google',
        googleConnected: 'Nakakonekta ang Google',
        googleConnectedWithEmail: 'Nakakonekta ang Google ({email})',
        connectApple: 'Ikonekta ang Apple',
        appleConnected: 'Nakakonekta ang Apple',
        appleConnectedWithEmail: 'Nakakonekta ang Apple ({email})',
        logoUuidMissing: 'Nawawala ang UUID ng logo ng kumpanya',
        googleConnectedToast: 'Nakakonekta ang Google account.',
        appleConnectedToast: 'Nakakonekta ang Apple account.'
    },
    menu: {
        invoices: 'Mga Invoice',
        estimates: 'Mga Estimate',
        purchaseOrders: 'Purchase Orders',
        items: 'Mga Item',
        clients: 'Mga Kliyente',
        expenses: 'Mga Gastos',
        reports: 'Mga Report',
        settings: 'Mga Setting',
        companyInfo: 'Impormasyon ng kumpanya',
        taxes: 'Mga Buwis',
        default: 'Default',
        customizeInvoice: 'I-customize ang invoice',
        sendFeedback: 'Magpadala ng Feedback',
        newReply: '1 bagong tugon',
        signOut: 'Mag-sign out',
        signOutConfirm: 'Sigurado ka bang mag-sign out?',
        addBusiness: 'Magdagdag ng negosyo',
        newBusinessTitle: 'Bagong negosyo',
        businessName: 'Pangalan ng negosyo',
        businessNamePlaceholder: 'Ilagay ang pangalan ng negosyo',
        createBusiness: 'Gumawa',
        businessNameRequired: 'Ilagay ang pangalan ng negosyo',
        createBusinessSuccess: 'Matagumpay na nagawa ang negosyo'
    },
    network: {
        loginExpired: 'Nag-expire na ang login, mangyaring mag-log in muli',
        requestTimeout: 'Nag-time out ang request, mangyaring suriin ang network'
    },
    language: {
        label: 'Wika',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        searchPlaceholder: 'Maghanap sa iyong mga invoice',
        addInvoice: 'Magdagdag ng invoice',
        overdueInvoices: 'Mga invoice na overdue',
        paidInvoices: 'Mga invoice na nabayaran',
        unpaidInvoices: 'Mga invoice na hindi nabayaran',
        unsentInvoices: 'Mga invoice na hindi pa naipapadala',
        columnNumber: 'Numero',
        columnClient: 'Kliyente',
        columnStatus: 'Status',
        statusFullyPaid: 'Lubusang nabayaran',
        statusPartial: 'Bahagya',
        statusOverdue: 'Overdue',
        statusUnsent: 'Hindi Pa Naipapadala',
        statusSent: 'Naipadala',
        statusOpened: 'Nabuksan',
        actionRecordPayment: 'Itala ang Pagbabayad',
        actionMarkAsSent: 'Markahan bilang Naipadala',
        actionCopy: 'Kopyahin',
        actionDelete: 'Tanggalin',
        copyDialogTitle: 'Kopyahin ang invoice',
        copyTargetType: 'Kopyahin sa',
        copyOptions: 'Mga opsyon sa pagkopya',
        copyClient: 'Kopyahin ang client',
        copyItems: 'Kopyahin ang mga item',
        copyAttachments: 'Kopyahin ang mga attachment',
        confirmDelete: 'Tanggalin itong invoice. Magpatuloy?',
        copySuccess: 'Invoice nakopya',
        copyFailed: 'Nabigong kopyahin',
        deleteSuccess: 'Invoice tinanggal',
        deleteFailed: 'Nabigong tanggalin',
        recordPaymentDialogTitle: 'Itala ang Pagbabayad',
        markAsFullyPaid: 'Markahan bilang lubusang nabayaran',
        formAmount: 'Halaga',
        formDate: 'Petsa',
        formPaymentMethod: 'Paraan ng Pagbabayad',
        formNote: 'Tala',
        allYears: 'Lahat ng taon',
        errorMorePaymentThanBalanceDue: 'Mas maraming bayad kaysa sa balanse na dapat bayaran',
        errorAmountMustBeGreaterThanZero: 'Dapat mas malaki sa zero ang halaga',
        dueDateToday: 'Ngayon',
        dueDateDaysAgo: '{days} araw ang nakalipas',
        dueDateInDays: 'sa {days} araw'
    },
    estimate: {
        pageTitlePurchaseOrders: 'Mga Purchase Order',
        pageTitleEstimates: 'Mga Estimate',
        searchPlaceholderPurchaseOrders: 'Maghanap sa iyong mga purchase order',
        searchPlaceholderEstimates: 'Maghanap sa iyong mga estimate',
        addPurchaseOrder: 'Magdagdag ng purchase order',
        addEstimate: 'Magdagdag ng estimate',
        columnNumber: 'Numero',
        columnClient: 'Kliyente',
        columnDate: 'Petsa',
        columnEmail: 'Email',
        columnStatus: 'Status',
        columnTotal: 'Kabuuan',
        statusUnsent: 'Hindi Pa Naipapadala',
        statusSent: 'Naipadala',
        actionMarkAsSent: 'Markahan bilang Naipadala',
        actionCopy: 'Kopyahin',
        actionDelete: 'Tanggalin',
        actionConvertToInvoice: 'I-convert sa invoice',
        copyDialogTitle: 'Kopyahin ang {document}',
        copyTargetType: 'Kopyahin sa',
        copyOptions: 'Mga opsyon sa pagkopya',
        copyClient: 'Kopyahin ang client',
        copyItems: 'Kopyahin ang mga item',
        copyAttachments: 'Kopyahin ang mga attachment',
        confirmDelete: 'Tanggalin itong {document}. Magpatuloy?',
        convertConfirm: 'I-convert itong {document} sa invoice? Ang petsa ay ilalagay sa ngayon.',
        copySuccess: '{document} nakopya',
        copyFailed: 'Nabigong kopyahin',
        convertSuccess: '{document} na-convert sa invoice',
        convertFailed: 'Nabigong i-convert',
        deleteSuccess: '{document} tinanggal',
        deleteFailed: 'Nabigong tanggalin',
        dueDateToday: 'Ngayon',
        dueDateDaysAgo: '{days} araw ang nakalipas',
        dueDateInDays: 'sa {days} araw'
    },
    item: {
        pageTitle: 'Mga Item',
        searchPlaceholder: 'Maghanap sa iyong mga item',
        addItem: 'Magdagdag ng item',
        columnInventoryCountUnit: 'Bilang ng Imbentaryo/Yunit'
    },
    client: {
        pageTitle: 'Mga Kliyente',
        searchPlaceholder: 'Maghanap sa iyong mga kliyente',
        addClient: 'Magdagdag ng kliyente',
        columnClientName: 'Pangalan ng Kliyente',
        columnEmail: 'Email',
        columnPhone: 'Telepono',
        columnBalanceDue: 'Balanse na Dapat Bayaran',
        noNameFallback: 'WALANG PANGALAN'
    },
    expense: {
        pageTitle: 'Mga Gastos',
        searchPlaceholder: 'Maghanap sa iyong mga gastos',
        addExpense: 'Magdagdag ng gastos',
        columnDescription: 'Paglalarawan',
        columnDate: 'Petsa',
        columnTotal: 'Kabuuan'
    },
    report: {
        headerTitle: 'Mga Report',
        tabDashboard: 'Dashboard',
        tabReportList: 'Listahan ng report',
        export: 'I-export',
        annualSalesByClient: 'Taunang benta ayon sa kliyente',
        totalOutstandingBalance: 'Kabuuang hindi pa nababayarang balanse',
        invoicesCountSuffix: 'mga invoice',
        byMonth: 'Ayon sa buwan',
        byQuarter: 'Ayon sa quarter',
        noSalesFound: 'Walang nahanap na benta',
        filterReportTypes: 'Mga uri ng report',
        filterTimePeriod: 'Panahon',
        filterView: 'Tingnan',
        optionMonthly: 'Buwanan',
        optionQuarterly: 'Quarterly',
        customerAgingTitle: 'Customer Aging',
        noDataForDateRange: 'Walang data para sa panahong ito',
        typeSalesByDate: 'Benta ayon sa Petsa',
        typeSalesByClient: 'Benta ayon sa Kliyente',
        typeSalesByItem: 'Benta ayon sa Item',
        typeSalesJournal: 'Journal ng Benta',
        typePaymentsByDate: 'Pagbabayad ayon sa Petsa',
        typePaymentsByClient: 'Pagbabayad ayon sa Kliyente',
        typePaymentsByType: 'Pagbabayad ayon sa Uri',
        typePaymentsJournal: 'Journal ng Pagbabayad',
        typeExpenseByCategory: 'Gastos ayon sa Kategorya',
        typeExpenseJournal: 'Journal ng Gastos',
        typeCustomerAging: 'Customer Aging',
        allYears: 'Lahat ng taon',
        allTime: 'Lahat ng oras',
        allSales: 'Lahat ng benta',
        taxYearSales: 'Benta ng tax year {year}',
        firstColumnMonth: 'Buwan',
        firstColumnQuarter: 'Quarter',
        columnSubTotal: 'Sub Total',
        columnTax: 'Buwis',
        columnDiscount: 'Diskwento',
        columnTotal: 'Kabuuan',
        columnAmountPaid: 'Nabayarang Halaga',
        columnAmountOwed: 'Utang na Halaga',
        columnClient: 'Kliyente',
        columnItem: 'Item',
        columnUnitType: 'Uri ng Yunit',
        columnQuantity: 'Dami',
        columnRateAvg: 'Rate (avg)',
        columnInvoiceDate: 'Petsa ng Invoice',
        columnInvoiceNo: 'Invoice No',
        columnType: 'Uri',
        columnPaymentDate: 'Petsa ng Pagbabayad',
        columnCategory: 'Kategorya',
        columnExpenseDate: 'Petsa ng Gastos',
        columnMerchant: 'Merchant',
        columnDescription: 'Paglalarawan',
        columnCurrentDue: 'Kasalukuyang Dapat Bayaran',
        column1To30DaysOverdue: '1-30 Araw na Overdue',
        column31To60DaysOverdue: '31-60 Araw na Overdue',
        column61To90DaysOverdue: '61-90 Araw na Overdue',
        column91PlusDaysOverdue: '91+ Araw na Overdue',
        monthNames: 'Jan, Feb, Mar, Apr, May, Jun, Jul, Aug, Sep, Oct, Nov, Dec',
        totalRowLabel: 'Kabuuan'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Magdagdag',
        invoicePrefix: 'prefix ng invoice',
        tabCreate: 'Lumikha',
        tabPreview: 'Preview',
        tabSendEmail: 'Magpadala ng Email',
        sectionClient: 'Kliyente',
        addClient: 'Magdagdag ng kliyente',
        dialogClientInfo: 'Impormasyon ng kliyente',
        basicInformation: 'Pangunahing impormasyon',
        labelName: 'Pangalan',
        labelEmail: 'Email',
        labelPhone: 'Telepono',
        billingAddress: 'Address ng pagbabayad',
        labelLine1: 'Linya 1',
        labelLine2: 'Linya 2',
        labelLine3: 'Linya 3',
        shippingAddress: 'Address ng pagpapadala',
        labelShippingName: 'Pangalan sa Pagpapadala',
        labelNotes: 'Mga Tala',
        placeholderCreateOrSelect: 'Lumikha o pumili ng isa...',
        placeholderClientNotes: "Magdagdag ng tala tungkol sa kliyente. Hindi nila makikita ito",
        sectionItems: 'Mga Item',
        saveToYourItem: 'I-save sa iyong item',
        stock: 'Stock:',
        placeholderItemCode: 'code ng item',
        placeholderQuantity: 'Dami',
        placeholderRate: 'rate',
        placeholderInputDescription: 'Ilagay ang paglalarawan',
        placeholderInputComment: 'Ilagay ang Komento',
        placeholderAddRecipient: 'Magdagdag ng tatanggap',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'Paksa ng email',
        placeholderMessage: 'Isulat ang iyong mensahe...',
        labelTo: 'Kay',
        labelSubject: 'Paksa',
        sectionAttachments: 'Mga Kalakip',
        sectionComment: 'Komento',
        addItem: 'Magdagdag ng item',
        addPhoto: 'Magdagdag ng larawan',
        addPayment: 'Magdagdag ng pagbabayad',
        goBack: 'bumalik',
        dialogShippingInfo: 'Impormasyon ng pagpapadala',
        dialogRecordPayment: 'Itala ang Pagbabayad',
        dialogJobDetails: 'Mga detalye ng trabaho',
        labelAmount: 'Halaga',
        labelShipDate: 'Petsa ng pagpapadala',
        labelShipVia: 'Ipadala sa pamamagitan ng',
        labelTrackingNumber: 'Numero ng tracking',
        labelFob: 'FOB',
        columnDate: 'Petsa',
        columnType: 'Uri',
        msgClientEmailError: 'error sa email ng kliyente',
        msgAmountGreaterThanZero: 'Dapat mas malaki sa zero ang halaga',
        msgMorePaymentThanBalance: 'Mas maraming bayad kaysa sa balanse na dapat bayaran',
        mailSentSuccessfully: 'Matagumpay na naipadala ang email',
        cumulativeTaxNotice: 'Hindi sinusuportahan ng web ang pagkaipon ng buwis sa invoice...',
        numberLogicNotice: 'Kamakailan naming binago ang lohika ng numero. Kung mali ang iyong numero, i-edit ito rito. Maaari ka ring pumunta sa Settings > Customize Invoice > Next Number at itakda ang nais mong panimulang numero.',
        confirmUnsavedChanges: 'Mayroon kang mga hindi na-save na pagbabago. Gusto mo ba itong i-save o itapon?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Buwis, diskwento at withholding',
        purchaseOrder: 'Purchase Order',
        placeholderPurchaseOrderPrefix: 'prefix ng purchase order',
        placeholderEstimatePrefix: 'prefix ng estimate',
        labelStatus: 'Status',
        statusIssued: 'Inisyu',
        statusApproved: 'Aprubado',
        statusPending: 'Nakabinbin',
        statusWithdrawn: 'Binitiw',
        tax: 'Buwis'
    },
    createEstimate: {
        pageTitlePrefix: 'Magdagdag',
        cumulativeTaxNotice: 'Hindi sinusuportahan ng web ang pagkaipon ng buwis sa estimate...'
    },
    updateInvoice: {
        pageTitlePrefix: 'I-update',
        deletePrefix: 'Tanggalin',
        confirmDelete: 'Tatanggalin nito ang invoice. Magpatuloy?',
        cumulativeTaxNotice: 'Naglalaman ang invoice na ito ng cumulative tax. Hindi pansamantalang sinusuportahan ng web ang function na ito'
    },
    updateEstimate: {
        pageTitlePrefix: 'I-update',
        deletePrefix: 'Tanggalin',
        confirmDelete: 'Tatanggalin nito ang {document}. Magpatuloy?',
        cumulativeTaxNotice: 'Naglalaman ang estimate na ito ng cumulative tax. Hindi pansamantalang sinusuportahan ng web ang function na ito'
    },
    createAccount: {
        title: 'Lumikha ng Account',
        placeholderEmail: 'email',
        placeholderPassword: 'Password',
        placeholderCompanyName: 'Pangalan ng Kumpanya',
        createAccountButton: 'Lumikha ng account',
        alreadyHaveAccount: 'Mayroon nang account?',
        signIn: 'Mag-sign in',
        validEmail: 'Mangyaring maglagay ng tamang email address',
        validPassword: 'Dapat ay 6 o higit pang character ang password',
        validCompanyName: 'Mangyaring punan ang pangalan ng iyong kumpanya'
    },
    clientCreate: {
        pageTitle: 'Magdagdag ng kliyente',
        basicInformation: 'Pangunahing impormasyon',
        labelName: 'Pangalan',
        placeholderName: 'Maglagay ng pangalan...',
        labelEmail: 'Email',
        placeholderEmail: 'Maglagay ng email address...',
        labelPhone: 'Telepono',
        placeholderPhone: 'Maglagay ng numero ng telepono...',
        billingAddress: 'Address ng pagbabayad',
        labelLine1: 'Linya 1',
        labelLine2: 'Linya 2',
        labelLine3: 'Linya 3',
        shippingAddress: 'Address ng pagpapadala',
        sameAsBilling: 'Katulad ng address ng pagbabayad',
        labelShippingName: 'Pangalan sa pagpapadala',
        labelShippingLine1: 'Linya 1',
        labelShippingLine2: 'Linya 2',
        labelShippingLine3: 'Linya 3',
        labelNotes: 'Mga Tala',
        placeholderNotes: "Magdagdag ng tala tungkol sa kliyente. Hindi nila makikita ito",
        validEmail: 'Mangyaring maglagay ng tamang email address'
    },
    clientUpdate: {
        pageTitle: 'I-update ang kliyente',
        confirmDelete: 'Tatanggalin nito ang kliyente. Magpatuloy?'
    },
    itemCreate: {
        pageTitle: 'Magdagdag ng item',
        itemTitle: 'Item',
        labelCost: 'Gastos',
        labelUnit: 'Yunit',
        placeholderUnit: 'Yunit',
        defaultTaxes: 'Default na mga buwis',
        taxOff: 'off',
        inventoryTitle: 'Imbentaryo',
        currentInventory: 'Kasalukuyang imbentaryo',
        adjustInventory: 'I-adjust ang imbentaryo',
        placeholderQuantity: 'Dami',
        placeholderDateAndTime: 'Petsa at oras',
        placeholderNote: 'Tala',
        addButton: 'Idagdag',
        columnDate: 'Petsa',
        columnQuantity: 'Dami',
        columnNote: 'Tala',
        withholdingTitle: 'Withholding',
        msgInventoryCannotDisable: 'Hindi maaaring i-disable ang imbentaryo kapag ito ay na-enable na',
        msgDescriptionRequired: 'Kailangan ang paglalarawan ng item',
        msgQuantityRequired: 'Kailangan ang dami',
        msgDateRequired: 'Kailangan ang petsa at oras'
    },
    itemUpdate: {
        pageTitle: 'I-edit ang item',
        columnInvoice: 'Invoice',
        confirmDelete: 'Tatanggalin nito ang item. Magpatuloy?'
    },
    createStatement: {
        pageTitle: 'Statement',
        tabPreview: 'Preview',
        tabSendEmail: 'Magpadala ng Email'
    },
    setting: {
        taxInfo: 'Impormasyon ng Buwis',
        taxes: 'Mga Buwis',
        taxYearStarts: 'Simula ng tax year',
        taxYearStartSubtitle: 'Itakda ang unang araw ng financial year',
        rateLabel: 'Rate(%)',
        abbreviation: 'Abbreviation',
        addTax: 'Magdagdag ng buwis',
        month: 'Buwan',
        day: 'Araw',
        monthPlaceholder: 'Buwan',
        dayPlaceholder: 'Araw',
        saveTaxYearStart: 'I-save',
        deleteDialogTitle: 'Tanggalin',
        confirmDeleteTax: 'Sigurado ka bang tanggalin ang buwis na ito?',
        deleteConfirm: 'Tanggalin',
        taxInfoDialogTitle: 'Impormasyon ng Buwis',
        taxName: 'Pangalan ng Buwis',
        standardRate: 'Standard na rate (%)',
        additionalRate: 'Karagdagang rate',
        deleteRateX: 'X',
        addRate: 'Magdagdag ng rate',
        taxType: 'Uri ng buwis',
        exclusive: 'Exclusive',
        inclusive: 'Inclusive',
        close: 'isara',
        saveTax: 'I-save ang buwis',
        cantOpenDetailMessage: 'Naglalaman ang buwis na ito ng cumulative tax. Hindi pansamantalang sinusuportahan ng web ang function na ito',
        closeButton: 'Isara',
        rateIsRequired: 'kailangan ang rate',
        rateIsRequiredMsg: 'Kailangan ang rate',
        monthAndDayRequired: 'Kailangan ang buwan at araw',
        moreRate: ' karagdagang rate',
        moreRates: ' karagdagang mga rate'
    },
    companyInfo: {
        title: 'Impormasyon ng Kumpanya',
        details: 'Mga Detalye',
        businessName: 'Pangalan ng negosyo',
        businessNamePlaceholder: 'Pangalan ng negosyo',
        name: 'Pangalan',
        phone: 'Telepono',
        email: 'Email',
        businessNumber: 'Numero ng Negosyo',
        taxNo: 'Tax N°',
        deleteField: 'tanggalin',
        addNewField: 'Magdagdag ng bagong field',
        address: 'Address',
        line1: 'Linya 1',
        line2: 'Linya 2',
        line3: 'Linya 3',
        currency: 'Currency',
        currencyLabel: 'Currency',
        symbol: 'Simbolo',
        placement: 'Pagkakalagay',
        before: 'Bago',
        after: 'Pagkatapos',
        thousandSymbol: 'Simbolo ng Libo',
        decimalSymbol: 'Simbolo ng Decimal',
        decimalPlaces: 'Mga Decimal Place',
        example: 'Halimbawa',
        terms: 'Mga Tuntunin',
        termsLabel: 'Mga Tuntunin',
        termSameDay: 'Araw ding Ito',
        term7Days: '7 Araw',
        term14Days: '14 Araw',
        term21Days: '21 Araw',
        term30Days: '30 Araw',
        term45Days: '45 Araw',
        term60Days: '60 Araw',
        term90Days: '90 Araw',
        term180Days: '180 Araw',
        term365Days: '365 Araw',
        paymentInfo: 'Impormasyon ng Pagbabayad',
        displayOnInvoices: 'Ipakita sa mga invoice',
        titlePlaceholder: 'Pamagat',
        jobDetails: 'Mga Detalye ng Trabaho',
        deleteJobDetail: 'tanggalin',
        addNewJobField: 'magdagdag ng bagong field'
    },
    default: {
        title: 'Default',
        emailMessage: 'Mensahe ng Email',
        enterDescription: 'Maglagay ng paglalarawan',
        emailCc: 'Email Cc',
        emailBcc: 'Email Bcc',
        emailTip: 'Magpadala ng email sa parehong oras sa address sa itaas.',
        defaultComments: 'Default na Komento',
        invoice: 'Invoice',
        estimate: 'Estimate',
        purchaseOrder: 'Purchase Order',
        creditMemo: 'Credit Memo',
        emailValidError: 'tamang email'
    },
    invoiceDesign: {
        template: 'Template',
        color: 'Kulay',
        labels: 'Mga Label',
        labelInvoice: 'Invoice',
        labelEstimate: 'Estimate',
        labelPurchaseOrder: 'Purchase order',
        labelCreditMemo: 'Credit memo',
        labelReceipt: 'RECEIPT',
        labelTermsFormat: 'Format ng tuntunin',
        labelBillTo: 'Ibabayad ni',
        labelFor: 'Para sa',
        labelDate: 'Petsa',
        labelInvoiceNo: 'Invoice no',
        labelEstimateNo: 'Estimate no',
        labelPoNo: 'PO no',
        labelCreditMemoNo: 'Credit memo no',
        labelDueDate: 'Petsa ng pagbabayad',
        labelTerms: 'Mga Tuntunin',
        labelAmount: 'Halaga',
        labelCode: 'Code',
        labelDescription: 'Paglalarawan',
        labelQuantity: 'Dami',
        labelRate: 'Rate',
        labelTax: 'Buwis',
        labelSubtotal: 'Subtotal',
        labelBalanceDue: 'Balanse na dapat bayaran',
        labelDiscount: 'Diskwento',
        labelNonTaxableItem: 'Item na hindi kinakaltasan ng buwis',
        labelPaid: 'Nabayaran',
        labelShipping: 'Pagpapadala',
        labelTotal: 'Kabuuan',
        labelIncludes: 'Kasama',
        labelTotalAmountPaid: 'Kabuuang Nabayarang Halaga',
        labelShipDate: 'Petsa ng Pagpapadala',
        labelShipTo: 'Ipadala kay',
        labelShipVia: 'Ipadala sa pamamagitan ng',
        labelTrackingNo: 'Tracking no',
        labelFob: 'F.O.B',
        prefix: 'Prefix',
        prefixInvoice: 'Invoice',
        prefixEstimate: 'Estimate',
        prefixPurchaseOrder: 'Purchase Order',
        prefixCreditMemo: 'Credit Memo',
        nextNumber: 'Susunod na Numero',
        numberingBeginsAt: 'Magsisimula ang numero sa',
        nextNumberInvoice: 'Invoice',
        nextNumberEstimate: 'Estimate',
        nextNumberPurchaseOrder: 'Purchase Order',
        nextNumberCreditMemo: 'Credit Memo',
        options: 'Mga Opsyon',
        optionTerms: 'Mga Tuntunin',
        optionDueDate: 'Petsa ng Pagbabayad',
        optionShippingAddress: 'Address ng pagpapadala',
        optionProductCode: 'Code ng produkto',
        optionQuantityAndRate: 'Dami at rate',
        optionTax: 'Buwis',
        optionAmount: 'Halaga',
        optionNonTaxableItemStar: 'Bituin sa item na hindi kinakaltasan ng buwis',
        optionTaxBreakdown: 'Pagkakahati ng Buwis',
        optionPaymentHistory: 'Kasaysayan ng pagbabayad',
        optionStamp: 'Stamp',
        optionPageNumber: 'Numero ng Pahina',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "Salamat sa iyong negosyo! Sana ay nasiyahan ka sa aming trabaho. Mangyaring magpadala ng bayad sa loob ng 15 araw.Mga tanong? Komento? Makipag-ugnayan sa amin sa(111)111-1234 o i-email sa example@owner.com, masaya kaming sagutin ang anumang tanong o alalahanin.",
        previewSubtotal: 'Subtotal',
        previewVat: 'VAT 17.00%',
        previewPayment1: 'Pagbabayad noong Oct 1, 2019',
        previewPayment2: 'Pagbabayad noong Oct 2, 2019'
    },
    feedback: {
        title: 'Magpadala ng Feedback',
        invalidEmailNoticePrefix: 'Di-wasto ang email address sa iyong account, kaya hindi ka namin makontak. Mangyaring ipadala ang iyong feedback mula sa wastong email address sa',
        invalidEmailNoticeSuffix: 'Kung posible, isama ang screenshot ng isyu; makakatulong ito sa amin na imbestigahan at malutas ito.',
        replyTip: 'Pagkatapos magpadala, mangyaring suriin ang iyong email para sa tugon.',
        content: 'Nilalaman',
        enterDescription: 'Maglagay ng paglalarawan'
    },
    createExpense: {
        title: 'Magdagdag ng Gastos',
        description: 'Paglalarawan',
        expenseDescriptionPlaceholder: 'Paglalarawan ng gastos',
        total: 'Kabuuan',
        tax: 'Buwis',
        tip: 'Tip',
        expenseDate: 'Petsa ng Gastos',
        merchant: 'Merchant',
        merchantPlaceholder: 'Ilagay ang pangalan ng merchant',
        categoryPlaceholder: 'Pumili ng kategorya',
        addNewCategory: 'Magdagdag ng bagong kategorya',
        deletePhoto: 'Tanggalin',
        addPhoto: 'Magdagdag ng larawan',
        deleteCategory: 'tanggalin',
        addCategory: 'Magdagdag ng kategorya'
    },
    updateExpense: {
        title: 'I-update ang Gastos',
        deleteExpense: 'Tanggalin ang Gastos',
        confirmDeleteMsg: 'Tatanggalin nito ang gastos. Magpatuloy?'
    },
    notFound: {
        oops: 'OOPS!',
        notFoundMsg: "Mukhang hindi namin mahanap ang pahina na hinahanap mo.",
        takeMeHome: 'Ibalik ako sa home'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Free Shipping',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Computer',
        previewItem2: 'Phone',
        previewItem3: 'Birthday cake',
        previewTaxRate: '17%',
        nonTaxableNote: '* Nagpapahiwatig ng item na hindi kinakaltasan ng buwis',
        thanksMessage: "Salamat sa iyong negosyo! Sana ay nasiyahan ka sa aming trabaho. Mangyaring magpadala ng bayad sa loob ng 15 araw.Mga tanong? Komento? Makipag-ugnayan sa amin sa(111)111-1234 o i-email sa example@owner.com, masaya kaming sagutin ang anumang tanong o alalahanin.",
        subtotal: 'Subtotal',
        vat: 'VAT 17.00%',
        payment1: 'Pagbabayad noong Oct 1, 2019',
        payment2: 'Pagbabayad noong Oct 2, 2019',
        balanceDue: 'Balanse na Dapat Bayaran'
    }
};
